var translationFunction = (t) => { return t; };
var getItemsPerPage = () => { return 10; };

export default {
  translationFunction,
  getItemsPerPage
}



/** WEBPACK FOOTER **
 ** ./src/app-settings/index.js
 **/